<div class="stores-header">
    <h3 class="title" *ngIf="title">{{translationHelper.localize(title)}}</h3>
    <div class="extra" *ngIf="description">
        {{translationHelper.localize(description)}}
    </div>
</div>